import { inject, Injectable } from '@angular/core';
import { debounceTime, tap, filter } from 'rxjs/operators';
import { BehaviorSubject, from, Observable, Subject } from 'rxjs';
import { ILsMoney, LsSchemaType } from '../models/ls.model';
import { LsSchemas } from '../models/lsSchemas';
import { AssuranceAndAssetInfo, Remain } from '@easy-lib/modules/money-receipt';
import { LsService } from './Ls.service';
import { apiUrls } from '../../../constants';
import { UserService } from '@easy-lib/modules/shared/services/user.service';
import { BaseService } from '@easy-lib/modules/shared/services/Base/base.service';

@Injectable({
	providedIn: 'root'
})
export class MoneyService extends BaseService {
	private buyPower: number;
	buyPower1: number;
	buyPower0: number;
	blockedBalance: number;
	balance: number;
	credit: number;
	totalAssuranceValue?: number;
	moneyInfo = new BehaviorSubject<{
		buyPower: number;
		buyPower1: number;
		buyPower0: number;
		blockedBalance: number;
		balance: number;
		credit: number;
	}>({
		buyPower: 0,
		buyPower1: 0,
		buyPower0: 0,
		blockedBalance: 0,
		balance: 0,
		credit: 0
	});
	moneyInfo$ = this.moneyInfo.asObservable();
	lastGetOrdersTime: Date;

	reloadBalanceSubject = new Subject();
	reloadBalanceObs$ = this.reloadBalanceSubject.asObservable();
	private lsService: LsService = inject(LsService);
	private userService: UserService = inject(UserService);
	constructor() {
		super();

		this.reloadBalanceObs$.pipe(debounceTime(1000)).subscribe(() => {
			this.doReloadBalance().subscribe();
		});
	}
	private accountBalanceSubject = new BehaviorSubject<number>(0);
	accountBalance$ = this.accountBalanceSubject.asObservable();
	get accountBalance(): number {
		return this.buyPower;
	}
	private set BuyPower(value: number) {
		this.buyPower = value;
		this.accountBalanceSubject.next(value);
	}
	reloadBalance(): void {
		this.reloadBalanceSubject.next(true);
	}

	subscribeLsForBalanceChanges(): void {
		this.subscribeToLs();
		this.lsService.resetLsManually$.pipe(filter(res => res)).subscribe(() => {
			this.subscribeToLs();
		});
	}
	subscribeToLs() {
		this.lsService.subscribeToLs(LsSchemaType.Money).subscribe(a => {
			if (a.name === LsSchemas.MoneySchema.meta) {
				const moneyBalances = JSON.parse(a.val) as ILsMoney;
				this.moneyInfo.next({
					...this.moneyInfo.value,
					buyPower: parseFloat(moneyBalances.buyPower),
					blockedBalance: parseFloat(moneyBalances.block),
					balance: parseFloat(moneyBalances.T2),
					credit: parseFloat(moneyBalances.credit)
				});
				this.buyPower = parseFloat(moneyBalances.buyPower);
				this.BuyPower = parseFloat(moneyBalances.buyPower);
				this.blockedBalance = parseFloat(moneyBalances.block);
				this.balance = parseFloat(moneyBalances.T2);
				this.credit = parseFloat(moneyBalances.credit);
			}
		});
	}

	getRemain(): Observable<Remain> {
		return this.httpService.get<Remain>(this.mtsPath + apiUrls.oms + 'money/');
	}

	getAssurance(): Observable<AssuranceAndAssetInfo> {
		return this.httpService.get<AssuranceAndAssetInfo>(this.mtsPath + apiUrls.tbs + 'AssuranceAndAssetInfo');
	}

	doReloadBalance(): Observable<Remain> {
		if (this.userService.isEasy2User || this.userService.isGuestUser) return from([]);
		return this.getRemain().pipe(
			tap(x => {
				this.BuyPower = +x.buyPower;
				this.moneyInfo.next({
					...this.moneyInfo.value,
					buyPower: +x.buyPower,
					blockedBalance: x.blocked,
					balance: x.balance,
					credit: x.credit,
					buyPower1: +x.buyPower1,
					buyPower0: +x.buyPower0
				});
				this.buyPower = +x.buyPower;
				this.blockedBalance = x.blocked;
				this.balance = x.balance;
				this.credit = x.credit;
				this.buyPower1 = +x.buyPower1;
				this.buyPower0 = +x.buyPower0;
			}),
			tap(res => {
				if (res.credit > 0) {
					this.getAssurance().subscribe(res => {
						this.totalAssuranceValue = res.totalAssuranceValue;
					});
				}
			})
		);
	}

	public calculatorBrokerAccountBalance(): number {
		const buyPowerForWalletWithoutCredit = Math.min(this.buyPower0 ?? 0, this.buyPower1 ?? 0, this.buyPower ?? 0);
		const buyPowerDifference = buyPowerForWalletWithoutCredit - (this.credit || 0);
		return Math.max(buyPowerDifference, 0);
	}
}
